import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Rocket, Trophy, Film, ArrowLeft, ShoppingBag, Scissors, PackageCheck } from "lucide-react";

/**
 * Shared header for the 4 storefront format pages.
 * Shows the store name, a back-to-hub link, and a compact format switcher.
 */
export default function StorefrontHeader({ active = null }) {
  const { pathname, search } = useLocation();
  const onHub = pathname === "/storefront";
  // Hide the entire header when the page is embedded via iframe (?embed=1).
  // The merchant's Shopify theme owns the header/footer in that case.
  if (new URLSearchParams(search).get("embed") === "1") return null;

  return (
    <header className="max-w-6xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between gap-4 flex-wrap border-b-2 border-[#0E0D0C]">
      <Link
        to="/storefront"
        className="dc-display text-2xl text-[#0E0D0C]"
        data-testid="storefront-logo"
      >
        Deluxxie
      </Link>

      {!onHub && (
        <nav className="flex items-center gap-1 text-xs" data-testid="storefront-format-nav">
          <Link
            to="/storefront"
            className="hidden sm:inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-[#3A3733] hover:text-[#0E0D0C] uppercase tracking-widest font-bold"
          >
            <ArrowLeft size={12} /> All
          </Link>
          <NavPill to="/storefront/launches" icon={Rocket} label="Drop Room" active={active === "launches"} />
          <NavPill to="/storefront/preorders" icon={ShoppingBag} label="Pre-orders" active={active === "preorders"} />
          <NavPill to="/storefront/just-dropped" icon={PackageCheck} label="Just Dropped" active={active === "just-dropped"} />
          <NavPill to="/the-cut" icon={Scissors} label="The Cut" active={active === "the-cut"} />
          {/* Hidden for launch: The Solo (competitions) and Reels. Re-enable when ready. */}
        </nav>
      )}
    </header>
  );
}

const NavPill = ({ to, icon: Icon, label, active }) => (
  <Link
    to={to}
    className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full font-bold uppercase tracking-widest transition-colors ${
      active ? "bg-[#0E0D0C] text-[#F2EFE9]" : "text-[#3A3733] hover:text-[#0E0D0C] hover:bg-[#E9E5DC]"
    }`}
    data-testid={`format-nav-${label.toLowerCase()}`}
  >
    <Icon size={12} />
    {label}
  </Link>
);
